import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@learningblocks/shared-components/lib/Modal";

/**
 * Modal Window Component for  ErrorCountBlock
 */
export function ErrorModalWindow(props) {
  return props.isModalOpen ? (
    <Modal
      isOpen={props.isModalOpen}
      size="sm"
      className="Modal sm"
      contentLabel={props.modalTitle}
    >
      {props.children}
    </Modal>
  ) : null;
}

ErrorModalWindow.propTypes = {
  /**
   * Child element to be displayed inside the Modal
   */
  children: PropTypes.element.isRequired,
  /**
   * Boolean varible controlling if the modal is open.
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Title string for the Modal.
   */
  modalTitle: PropTypes.string.isRequired,
};
